import { isPlatform } from '@ionic/react';
import { EquipmentFlow } from '../../schemas/Exicution/exicution.schema';
import {
  EXECUTIONSTATUS,
  TRAILER_PARTTEN,
  BOBTAIL
} from '../../utils/constants';
import { StopActivityProps } from '../stopActivity.model';
import { trailerRegConfig } from "../../utils/constants";
import { dayjs } from '../../utils/Date/DateUtil';

export class StartTripModel {
  static getInvalidTrailer:any = null;
  static invalidTrailerStop:any = null;
  static trailerOutUpdate:any = '';
  public getTimeWithTimezone(timeZone: any): any {
    try{
    return this.getTimeForIOS(dayjs().tz(timeZone).format());
    }
    catch{
      return this.getTimeForIOS(dayjs().format());
    }
  }

  public isIOSPlatform(): boolean {
    return isPlatform('ios') || isPlatform('ipad') || isPlatform('iphone');
  }

  public getTimeForIOS(date: any): any {
    if (!date) {
      date = '';
    }
    try{
    const localZone = dayjs.tz.guess();
    return dayjs(date.substring(0, 16)).tz(localZone).format();
    }
    catch{
     return dayjs(date.substring(0, 16)).format();
    }
  }

  /*
   * get the current year value
   */
  public yearsValue(): number {
    const _date = new Date();
    return _date.getFullYear();
  }

  /*
   * get the shipment status that staop has been confirmed or not
   * @shipment - shipment for the trip
   */
  public isConfirmStartButtonDisabled(shipment: any): boolean {
    const { startCity, startState, startDateTime } = shipment || {};
    return (startCity || startState) && startDateTime;
  }

  /**
   * get the shipment stop status from API response.
   ** @param data : stop status with additional information.
   */
  public stopStatus(data: any) {
    if (data) {
      const TrailerOut:any = (!data.status && !!data.message) ? /TA[\d]{6}\s/.test(data.message) ? ((data.message.match(/TA[\d]{6}\s/))[0]).trim(): null : null;
      StartTripModel.getInvalidTrailer = TrailerOut;
      StartTripModel.trailerOutUpdate = Math.random();
    }
  }

   /**
   * Determine if current stop has invalid trailer or not.
   ** @param load : shipment details.
   ** @param stopDetail : stop details.
   */
  public hasInvalidTrailer (load:any, stopDetail:any):boolean{
    let getTrailerOut = null;
    let stophasInvalidTrailer = true;
    if(StartTripModel.getInvalidTrailer){
    if (load.managedEquipment && stopDetail.stopActivity && stopDetail.stopActivity.length > 0) {
      const activity = stopDetail.stopActivity.find((e: StopActivityProps) => e.equipmentFlow === EquipmentFlow.TRAILER_OUT) || {};
      getTrailerOut = activity.equipmentId;
    }
    stophasInvalidTrailer = StartTripModel.getInvalidTrailer === getTrailerOut;
    }
    return stophasInvalidTrailer;
  }
  public removeGetInvalidTrailer (){
    StartTripModel.getInvalidTrailer = null;
  }
  /*
   * get the starting location of the trip
   * @shipment - shipment for the trip
   */
  public getStartingLocation(shipment: any): string {
    const { startCity, startState } = shipment || {};
    return `${startCity}${startState ? ', ' : ''}${startState}`.trim();
  }

  /*
   * get the stating date of the shipment
   * @shipment - shipment for the trip
   */
  public getStartingDateTime(shipment: any): string {
    const { startDateTime } = shipment || {};
    return startDateTime;
  }

  /*
   * get the current open stop
   * @shipment - shipment for the trip
   */
  public getCurrentOpenStop(shipment: any, allowUpdateStop?: boolean): number {
    let openStop = 0;
    if (this.isConfirmStartButtonDisabled(shipment)) {
      openStop = 0;
    }
    if (shipmentStopCheck(shipment)) {
      let loadStop: any[] = shipment.loadStop || [];
      loadStop = loadStop.slice().sort((load1: any, load2: any) => {
        if (loadSequenceCheck(load1, load2)) {
          return load1.sequenceNo - load2.sequenceNo;
        }
        if (loadStopSequenceCheck(load1, load2)) {
          return load1.stopSequence - load2.stopSequence;
        }
        return 0;
      });
      loadStop.forEach((load: any, index: number) => {
        let trailerOut = null;
        if (shipment.managedEquipment && load.stopActivity && load.stopActivity.length > 0) {
          const activity = load.stopActivity.find((e: StopActivityProps) => e.equipmentFlow === EquipmentFlow.TRAILER_OUT) || {};
          trailerOut = activity.equipmentId;
        }
        if (allowUpdateStop) {
          if (trailerOut === null) {
            openStop = index;
            return
          }
        } else {
          openStop = shipmentAndManageEquipmentCheck(shipment, load, openStop, index, trailerOut);
        }
      });
    }
    return openStop;
  }

  /*
   * is all stop completed or not
   * @shipment - shipment for the trip
   */
  public isAllStopCompleted(shipment: any): boolean {
    let allStopCompleted = false;
    if (shipment && shipment.loadStop) {
      let loadStop: any[] = shipment.loadStop || [];
      loadStop = loadStop.slice().sort((load1: any, load2: any) => {
        if (load1.sequenceNo && load2.sequenceNo) {
          return load1.sequenceNo - load2.sequenceNo;
        }
        if (load1.stopSequence && load2.stopSequence) {
          return load1.stopSequence - load2.stopSequence;
        }
        return 0;
      });
      
      if (loadStop.length > 0 ) {
        allStopCompleted = !!loadStop[loadStop.length - 1].actualDepartureDateTime && !StartTripModel.getInvalidTrailer;
      } else {
        allStopCompleted = true;
      }
    }
    return allStopCompleted;
  }

  public isTripCompleted(shipment: any): boolean {
    return (
      (shipment && shipment.executionStatus === EXECUTIONSTATUS.COMPLETED) ||
      false
    );
  }

  /*
   * get the ETA value
   * @loadStop - loadStop of the shipment
   */
  public getETA(loadStop: any): string {
    // estimatedArrivalDateTime -- planned ETA
    const {
      estimatedArrivalDateTime,
      actualETADateTime,
      appointmentEarlyDateTime,
      plannedEtaDateTime,
    } = loadStop;
    let etaTime = '';
    if (actualETADateTime) {
      etaTime = actualETADateTime;
    } else if (plannedEtaDateTime) {
      etaTime = plannedEtaDateTime;
    } else if (appointmentEarlyDateTime) {
      etaTime = appointmentEarlyDateTime;
    } else if (estimatedArrivalDateTime) {
      etaTime = estimatedArrivalDateTime;
    }
    if (etaTime) {
      etaTime = this.getTimeForIOS(etaTime);
    }
    return etaTime || '';
  }

  /*
   * get the arrival value
   * @loadStop - loadStop of the shipment
   */
  public isOTMTypeShipment(shipment: any): boolean {
    let isOTMType = false;
    if (shipment && shipment.managedEquipment === true) {
      isOTMType = true;
    }
    return isOTMType;
  }

  /*
   * set the initital value for arrival
   * @loadStop - loadStop of the shipment
   */
  public getArrivalOnClick(
    loadStop: any,
    isNextStop: boolean,
    arrivalInput: string
  ): string {
    const { appointmentEarlyDateTime, actualArrivalDateTime } = loadStop;
    if (isNextStop) {
      return '';
    }
    if (arrivalInput) {
      return arrivalInput;
    }
    let arrivalTime = '';
    if (actualArrivalDateTime) {
      arrivalTime = actualArrivalDateTime;
    } else if (appointmentEarlyDateTime) {
      arrivalTime = appointmentEarlyDateTime; // .substring(0, 16);
    }

    return arrivalTime;
  }

  /*
   * get the arrival lable name
   * @loadStop - loadStop of the shipment
   */
  public getArrivalLabelName(loadStop: any, isNextStop: boolean): string {
    const { actualArrivalDateTime } = loadStop;

    return actualArrivalDateTime && !isNextStop ? 'Arrived' : 'Arrival';
  }

  public isOTypeStop(load: any): boolean {
    let oType = false;
    if (loadStopTypeCheck(load)) {
      oType = true;
    }
    return oType;
  }

  /*
   * get the stating date of the shipment
   * @shipment - shipment for the trip
   */
  public getDepartureOnClick(
    loadStop: any,
    isNextStop: boolean,
    departureInput: string
  ): string {
    const { appointmentLateDateTime, actualDepartureDateTime } = loadStop;
    if (isNextStop) {
      return '';
    }
    if (departureInput) {
      return departureInput;
    }
    let deaprtureTime = '';
    if (actualDepartureDateTime) {
      deaprtureTime = actualDepartureDateTime;
    } else if (appointmentLateDateTime) {
      deaprtureTime = appointmentLateDateTime; // .substring(0, 16);
    }

    return deaprtureTime;
  }

  /*
   * get the departure lable name
   * @loadStop - loadStop of the shipment
   */
  public getDepartureLabelName(loadStop: any): string {
    const { actualDepartureDateTime } = loadStop;

    return actualDepartureDateTime ? 'Departed' : 'Departure';
  }

  public getFormattedDate(date: string): string {
    let dateString = '';
    if (date) {
      let hr = Number(date.substring(11, 13));
      const min = Number(date.substring(14, 16));
      hr = hr % 12 || 12;
      dateString = `${date.substring(0, 11)}${`0${hr}`.slice(
        -2
      )}:${`0${min}`.slice(-2)}`;
    }
    return dateString;
  }
  public getTimeZone(loadStop: any) {
    const { timeZone } = loadStop;
    return timeZone;
  }

  public getCurrentTimeInISO(): string {
    const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
    return new Date(Date.now() - tzoffset).toISOString().slice(0, -1);
  }

  public isShipmentTripCompleted(shipment: any): boolean {
    let status = false;
    if (shipment && shipment.executionStatus === EXECUTIONSTATUS.COMPLETED) {
      status = true;
    }

    return status;
  }
  public showTrailerInError(
    value: string,
    shipment: any,
    departure: string,
    isNextStop: boolean,
    loadStop: any,
    isUtilizingSchneiderEquipment: boolean
  ): boolean {
    if (
      (this.isManagedEquipmentWithTrailerValidation(value, shipment) || isUtilizingSchneiderEquipment) &&
      !value &&
      !isNextStop &&
      (!(loadStop && loadStop.actualDepartureDateTime) ? departure : false)
    ) {
            return true;
    }
    
    return false;
  }

  public showTrailerOutError(
    value: string,
    shipment: any,
    departure: string,
    isNextStop: boolean,
    loadStop: any,
    isUtilizingSchneiderEquipment: boolean
  ): boolean {
    if (
      (this.isManagedEquipmentWithTrailerValidation(value, shipment) || isUtilizingSchneiderEquipment) &&
      !value &&
      !isNextStop &&
      (!(loadStop && loadStop.actualDepartureDateTime) ? departure : false)
    ) {
      return true;
    }

    return false;
  }

  public isManagedEquipmentWithTrailerValidation(
    value: string,
    shipment: any,
  ): boolean {
    if (!value && !shipment.managedEquipment) {
      return false
    } else {
      if (value) {
        const validationBasedOnTrailer = trailerRegConfig.find(trailer => {
          return !(!!value.indexOf(trailer.type))
        }) as any
        return validationBasedOnTrailer && validationBasedOnTrailer.expression ? !validationBasedOnTrailer.expression.test(value) : false
      }
      else {
        return true
      }
    }
  }
  /*
   * get the trailer in value
   * @loadStop - loadStop of the shipment
   * @bobtail - bobtail status
   * activity details
   */
  public getTrailerIn(
    loadStop: any,
    shipment: any,
    updateStopInfo?: any,
    hardstopstatus?:any
  ): {
    trailerIn: string;
    activity?: StopActivityProps;
    trailerInUpd?:any
  } {
    let trailerIn = '';
    let trailerInUpd = '';
    let activity: StopActivityProps | undefined;
    const isOtmType = this.isOTMTypeShipment(shipment);
    const isOtype = this.isOTypeStop(loadStop);
    if (isOtype) {
      trailerIn = '';
    } else if (
      loadStop &&
      loadStop.stopActivity &&
      loadStop.stopActivity.length > 0
    ) {
      activity =
        loadStop.stopActivity.find((e: StopActivityProps) => {
          return e.execActivity === EquipmentFlow.TRAILER_IN;
        }) || {};

      trailerIn = getTrailerInValue(activity, trailerIn);
      const updatedStopSno = updatedStopInfo(updateStopInfo);
      const prevStopSno = getPreviousStop(loadStop);
      trailerInUpd = StartTripModel.trailerOutUpdate;
      trailerIn = updatedStopInfoCheck(updatedStopSno, prevStopSno, shipment, loadStop, trailerIn);
    }
    trailerIn = trailerIn && trailerIn.toUpperCase();
    if (isOtmType) {
      if (trailerIn && (trailerIn.indexOf(BOBTAIL) !== -1 || trailerIn.indexOf("SNLU") !== -1 || trailerIn.indexOf("TA") !== -1)) {
        if (!TRAILER_PARTTEN.test(trailerIn)) {
          trailerIn = '';
        }
      }
    }
    return { trailerIn, activity, trailerInUpd };
  }

  /*
   * get the trailer out
   * @loadStop - loadStop of the shipment
   * @bobtail - bobtail status
   * activity details
   */
  public getTrailerOut(
    loadStop: any,
    shipment: any
  ): {
    trailerOut: string;
    activity?: StopActivityProps;
    trailerOutUpd?: string
  } {
    let trailerOut = '';
    let trailerOutUpd = '';
    let activity: StopActivityProps | undefined;
    if (loadStop && loadStop.stopActivity && loadStop.stopActivity.length > 0) {
      activity =
        loadStop.stopActivity.find((e: StopActivityProps) => {
          return e.execActivity === EquipmentFlow.TRAILER_OUT;
        }) || {};

      if (activity) {
        trailerOut = `${activity.equipmentId || ''}`;
      }
    }
    const isOtmType = this.isOTMTypeShipment(shipment);
    trailerOut = trailerOut && trailerOut.toUpperCase();
    let invalidTrailer = StartTripModel.getInvalidTrailer;
    trailerOutUpd = StartTripModel.trailerOutUpdate;
    trailerOut = isOTMTypeCheckDetails(isOtmType, trailerOut, invalidTrailer);
    return { trailerOut, activity, trailerOutUpd};
  }
 
  /*
   * validate whether IN activity avilable or not
   * @activity - stop activities
   */
  public isInActivityAvailable(activity: StopActivityProps[]): boolean {
    return (
      (activity &&
        activity.filter(
          (a: StopActivityProps) => a.equipmentFlow === EquipmentFlow.TRAILER_IN
        ).length > 0) ||
      false
    );
  }

  /*
   * validate whether OUT activity avilable or not
   * @activity - stop activities
   */
  public isOutActivityAvailable(activity: StopActivityProps[]): boolean {
    return (
      (activity &&
        activity.filter(
          (a: StopActivityProps) =>
            a.equipmentFlow === EquipmentFlow.TRAILER_OUT
        ).length > 0) ||
      false
    );
  }

  /*
   * Check whether stop activities are missing or not
   * @activity - stop activities
   */
  public areStopActivitiesMissing(load: any): boolean {
    const activity: StopActivityProps[] = (load && load.stopActivity) || [];
    const newActivity: StopActivityProps[] = [];
    activity.forEach((item: StopActivityProps) => {
      if ((item.tmsActivity || '').toUpperCase().trim() !== 'bobtail') {
        newActivity.push(item);
      }
    });
    return newActivity.length === 0 || false;
  }

  public getCurrentLocalDateString(timeZone: string): string {
    const date = new Date();
    let dateString = '';
    if (timeZone) {
      dateString = date.toLocaleString('en-US', {
        timeZone,
      });
    } else {
      dateString = date.toISOString();
    }

    return dateString;
  }
  /*
   * check whether Departure is readonly or not
   * @loadStop - loadStop of the shipment
   */
  public isDepartureReadonly(loadStop: any, arrivalVal: string): boolean {
    const { actualDepartureDateTime, actualArrivalDateTime } = loadStop;
    let readonly = false;
    if (!!!actualArrivalDateTime) {
      readonly = true;
    }
    if (arrivalVal) {
      readonly = false;
    }
    if (actualDepartureDateTime) {
      readonly = true;
    }

    return readonly;
  }

  /*
   * check whether Arrival is readonly or not
   * @loadStop - loadStop of the shipment
   */
  public isArrivalReadonly(loadStop: any): boolean {
    const { actualDepartureDateTime, actualArrivalDateTime } = loadStop;
    let readonly = false;
    if (actualDepartureDateTime || actualArrivalDateTime) {
      readonly = true;
    }

    return readonly;
  }

  /*
   * get the departure value
   * @loadStop - loadStop of the shipment
   */
  public isStopCompleted(loadStop: any): boolean {
    let { actualDepartureDateTime } = loadStop;

    return !!actualDepartureDateTime;
  }

  public getRoundOffTime(value: string): string {
    let coeff = 1000 * 60 * 5;
    let date = new Date();  //or use any other date
    let rounded = new Date(Math.ceil(date.getTime() / coeff) * coeff)
    const timeString = rounded.toTimeString().slice(0, 8);
    value = value && value.replace('00:00:00', timeString);
    return value;
  }
}
const loadStopSequenceCheck=(load1: any, load2: any)=> {
  return load1.stopSequence && load2.stopSequence;
}

const loadSequenceCheck=(load1: any, load2: any)=> {
  return load1.sequenceNo && load2.sequenceNo;
}

const shipmentStopCheck=(shipment: any)=> {
  return shipment && shipment.loadStop;
}

const shipmentAndManageEquipmentCheck=(shipment: any, load: any, openStop: number, index: number, trailerOut: any) =>{
  if (shipment.managedEquipment && load.actualDepartureDateTime) {
    openStop = index + 1;
    if (StartTripModel.getInvalidTrailer && StartTripModel.getInvalidTrailer === trailerOut) {
      openStop = openStop - 1;
    }
  } else {
    if (!shipment.managedEquipment && load.actualDepartureDateTime) {
      openStop = index + 1;
    }
  }
  return openStop;
}

const loadStopTypeCheck=(load: any) =>{
  return load && load.stopType === 'O';
}

const getTrailerInValue=(activity: StopActivityProps | undefined, trailerIn: string) =>{
  if (activity) {
    trailerIn = `${activity.equipmentId || ''}`;
  }
  return trailerIn;
}

const updatedStopInfoCheck=(updatedStopSno: any, prevStopSno: any, shipment: any, loadStop: any, trailerIn: string) =>{
  if (updatedStopSno === prevStopSno) {
    const loads: any[] = (shipment && shipment.loadStop) || [];
    const load = loads.filter(
      (item: any) => item.sequenceNo === loadStop.sequenceNo - 1
    );
    if (load.length > 0) {
      const _activity = (load[0].stopActivity &&
        load[0].stopActivity.find((e: StopActivityProps) => {
          return e.equipmentFlow === EquipmentFlow.TRAILER_OUT;
        })) ||
        {};
      const isTrailerValid = StartTripModel.getInvalidTrailer === _activity.equipmentId;
      trailerIn = !!isTrailerValid ? '' : _activity.equipmentId;

    }
  }
  return trailerIn;
}

const isOTMTypeCheckDetails=(isOtmType: boolean, trailerOut: string, invalidTrailer: any) =>{
  if (isOtmType) {
    if (trailerOut && trailerOut.indexOf("BOBTAIL") !== -1 || trailerOut.indexOf("SNLU") !== -1 || trailerOut.indexOf("SNCZ") !== -1 || trailerOut.indexOf("TA") !== -1) {
      if (!TRAILER_PARTTEN.test(trailerOut)) {
        trailerOut = '';
      }
    }
  }
  return trailerOut;
}

function getPreviousStop(loadStop: any) {
  return loadStop && loadStop.sequenceNo - 1;
}

function updatedStopInfo(updateStopInfo: any) {
  return updateStopInfo && updateStopInfo.sequenceNo;
}